import { SIDEBAR_CONTENT_ID } from 'client/constants/editorIds'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { SettingsNestedMenuProps } from 'src/editor/layout/sidebar/settings/settings-nested-menu'
import { SettingsNestedMenuScreen } from 'src/editor/layout/sidebar/settings/settings-nested-menu/settings-nested-menu-screen'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { LocoAssetsKeysType } from 'src/shared/i18next/types/loco-assets-keys-type'
import {
  FormSubEntitySettingsMenuButton,
  FormSubEntitySettingsMenuButtonProps,
} from './form-sub-entity-settings-menu-button'

interface FormSubEntitiesSettingsNestedMenuItemProps
  extends Pick<SettingsNestedMenuProps, 'isOpen' | 'onClose'>,
    Pick<
      FormSubEntitySettingsMenuButtonProps,
      'hideDeleteButton' | 'onDelete'
    > {
  /**
   * Raw locale key. The inner `SettingsMenuItem` runs `t(title)` itself,
   * so passing a pre-translated string would double-translate and render
   * empty on prod (`parseMissingKeyHandler: () => ''`).
   */
  title: LocoAssetsKeysType
  children: React.ReactNode
  icon: FormSubEntitySettingsMenuButtonProps['iconBefore']
}

export const FormSubEntitiesSettingsNestedMenuItem = ({
  title,
  children,
  icon,
  isOpen: isOpenFromProps,
  onDelete,
  hideDeleteButton,
  onClose,
}: FormSubEntitiesSettingsNestedMenuItemProps) => {
  const { t } = useTypedTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const onBack = () => {
    setIsOpen(false)
    onClose?.()
  }
  return (
    <>
      <FormSubEntitySettingsMenuButton
        title={title}
        iconBefore={icon}
        onDelete={onDelete}
        hideDeleteButton={hideDeleteButton}
        onClick={() => setIsOpen(true)}
      />
      {(isOpenFromProps ?? isOpen) &&
        ReactDOM.createPortal(
          <SettingsNestedMenuScreen title={t(title)} onClose={onBack}>
            {children}
          </SettingsNestedMenuScreen>,
          document.getElementById(SIDEBAR_CONTENT_ID) as HTMLElement,
        )}
    </>
  )
}
